export const TABS_SX = {
  mb: 0,
  minHeight: '48px',
  height: '48px',
  '& .MuiTab-root': {
    minWidth: 120,
    minHeight: '48px',
    height: '48px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    color: 'text.secondary',
    '&.Mui-selected': {
      color: 'info.main',
      fontWeight: 600,
    },
  },
  '& .MuiTabs-indicator': {
    backgroundColor: 'info.main',
    height: 3,
  },
};

export const SUPPORTED_FILE_EXTENSIONS = {
  csv: 'csv',
  xlsx: 'xlsx',
  pdf: 'pdf',
  png: 'png',
  jpg: 'jpg',
  jpeg: 'jpeg',
} as const;

export const DEFAULT_HEIGHTS = {
  mainArea: 400,
  minHeight: 400,
  rowHeight: 24,
} as const;

export const DEFAULT_SPLITS = {
  topBottom: 50,
  sideBySide: 50,
} as const;

export const RESIZER_STYLES = {
  width: '4px',
  height: '4px',
  backgroundColor: 'grey.300',
  position: 'relative' as const,
  '&:hover': {
    backgroundColor: 'info.main',
  },
};

export const PAPER_STYLES = {
  elevation: 2,
  border: '1px solid',
  borderColor: 'info.main',
  borderRadius: 2,
  overflow: 'hidden' as const,
  display: 'flex',
  flexDirection: 'column' as const,
};

export const AI_CONTEXT_INSTRUCTIONS = `Focus on rebate-specific data extraction:
- Base purchase amounts or qualifying volumes
- Product groups or categories eligible for rebates
- Buy Name, preferrably by Division or entity breakdowns
- Supplier names or IDs
- Earned rebate amounts and calculations
- Dates of purchase or calculation periods

Ensure the CSV maintains the relationship between purchase volumes, applicable rates, and calculated rebate amounts. Include any reference numbers or identifiers that link to underlying transactions.`;

export const VIEW_MODES = {
  sideBySide: 'side-by-side',
  topBottom: 'top-bottom',
  singleView: 'single-view',
} as const;

export type ViewMode = (typeof VIEW_MODES)[keyof typeof VIEW_MODES];
